import { render, staticRenderFns } from "./Stvrt.vue?vue&type=template&id=2f69775d&scoped=true"
import script from "./Stvrt.vue?vue&type=script&lang=js"
export * from "./Stvrt.vue?vue&type=script&lang=js"
import style0 from "./Stvrt.vue?vue&type=style&index=0&id=2f69775d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f69775d",
  null
  
)

export default component.exports